<template>
  <div class="stillberatung">
    <h1>Stillberatung in Koblenz: Professionelle Hilfe bei Stillproblemen</h1>
    <p>Stillen ist eine wunderbare, aber nicht immer intuitive Erfahrung. Ich begleite euch einfühlsam in allen Fragen und Herausforderungen der Stillzeit.</p>
    <h2>Individuelle Stillberatung bei diesen Themen:</h2>
    <ul>
      <li>Stillvorbereitung</li>
      <li>Schwieriger Stillstart</li>
      <li>Habe ich zu wenig oder zu viel Milch?</li>
      <li>Schmerzen beim Stillen</li>
      <li>Stillen nach Kaiserschnitt</li>
      <li>Nimmt mein Baby genug zu?</li>
      <li>Brustverweigerung („Stillstreik“)</li>
      <li>Hilfe bei Milchstau oder Brustentzündung / wunden Brustwarzen</li>
      <li>Saugverwirrung</li>
      <li>Ern&auml;hrung in der Stillzeit</li>
      <li>Medizinische Untersuchungen in der Stillzeit</li>
      <li>Tandemstillen</li>
      <li>Hilfsmittel / stillfreundliches Zuf&uuml;ttern</li>
      <li>Stillpausen</li>
      <li>Abstillen</li>
      <li>uvm.</li>
    </ul>
    <p>Du bist schwanger und hast noch gar keine konkreten Fragen? Ich biete auch <router-link to="/stillvorbereitung/">Stillvorbereitungskurse</router-link> an, damit ihr bestens informiert startet!</p>
    <button 
      class="cta-button" 
      @click="$router.push({ 
        path: '/kontakt', 
        query: { 
          topic: 'Stillberatung' 
        } 
      })"
    >
      Jetzt Kontakt aufnehmen
    </button>
  </div>
</template>

<script>
export default {
  name: 'Stillberatung'
}
</script>

<style scoped>
.stillberatung {
}
</style>